/* bt-design-request.js — «Хай зробить дизайнер: оплата після макета».
 *
 * Живе В АСЕТІ, а не в блоці set-option-cards-v2-designer.liquid, бо блок
 * упирається в ліміт Shopify ~300 000 символів на файл (пуш валиться з
 * FILE_VALIDATION_ERROR). Блок лишає собі лише шим REQX (замикання візарда:
 * totals/typePrice/L/стан) і кличе window.BTDesignRequest.init/submit.
 *
 * Що робить: підміняє тексти дизайнерського шляху на «оплата після макета»,
 * домальовує в крок контакту обовʼязкове поле контакту і завантаження фото,
 * додає фінальний екран «заявку прийнято», а сабміт шле заявку на склад
 * (/api/public/design-request) замість /cart/add. Фото ужимаються до 1800px
 * JPEG (ліміт тіла складового API ~4 МБ) і шляться по одному, best-effort.
 *
 * Бекенд і вкладка «Заявки на макет» — sklad/slkad/DESIGN-REQUESTS-GUIDE.md.
 */
(function () {
  'use strict';

  var T = {
    pl: {
      nameLbl: 'Twoje imię',
      namePh: 'Jak się do Ciebie zwracać?',
      contactLbl: 'Twój kontakt',
      contactPh: 'Telefon / @nick / e-mail',
      contactPhBy: { whatsapp: 'Numer telefonu z WhatsApp, np. +48 600 000 000', instagram: 'Twój @nick na Instagramie', messenger: 'Imię i nazwisko na Facebooku', telegram: 'Telefon lub @nick w Telegramie', viber: 'Numer telefonu z Viber' },
      emailLbl: 'Twój e-mail',
      emailPh: 'np. anna@gmail.com',
      emailBad: 'Wpisz poprawny adres e-mail — bez niego nie wyślemy zgłoszenia.',
      emailHint: 'Obowiązkowo — na e-mail wyślemy makietę, jeśli w komunikatorze się nie uda.',
      photosLbl: 'Dodaj zdjęcia od razu',
      photosBtn: '📸 Wybierz zdjęcia',
      photosHint: 'Można też później — napiszemy do Ciebie na podany kontakt.',
      consentTxt: 'Wyrażam zgodę na przetwarzanie moich danych osobowych i przesłanych zdjęć w celu przygotowania makiety i kontaktu w sprawie zgłoszenia.',
      consentLink: 'Polityka prywatności',
      submit: 'Wyślij zgłoszenie',
      sending: 'Wysyłam…',
      doneTitle: 'Zgłoszenie przyjęte! 🎉',
      doneText: 'Projektant przygotuje makietę i wyśle ją na podany kontakt. Zapłacisz dopiero wtedy, gdy zaakceptujesz makietę.',
      doneBtn: 'Super, czekam!',
      msgHeading: 'Napisz do nas pierwszy — inaczej nie możemy się odezwać',
      msgWhy: 'Makietę wyślemy właśnie w komunikatorze. Meta (Instagram, WhatsApp i Messenger) pozwala firmom pisać tylko do osób, które odezwały się pierwsze — jedna Twoja wiadomość i projektant będzie mógł wysłać makietę i dopytać o szczegóły.',
      msgBadge: 'Bez reklam i spamu',
      msgPromise: 'Obiecujemy: piszemy wyłącznie w sprawie Twojego zgłoszenia.',
      btnWhatsapp: 'Napisz na WhatsApp',
      btnInstagram: 'Napisz na Instagramie',
      btnMessenger: 'Napisz na Messengerze',
      bestBadge: 'Najszybciej odpowiadamy',
      btnTelegram: 'Napisz w Telegramie',
      msgTemplate: 'Dzień dobry! Moje zgłoszenie na makietę {no}. Imię: {name}.',
      msgHint: 'Podaj w wiadomości numer zgłoszenia {no} (imię: {name}) — od razu Cię znajdziemy.',
      photosSending: 'Wysyłamy zdjęcia ({n}/{m})…',
      photosDone: 'Zdjęcia wysłane ✅',
      photosFail: 'Nie wszystkie zdjęcia się wgrały — po prostu wyślij je w komunikatorze.',
      btnEmail: 'Napisz e-mail',
      emailSubject: 'Zgłoszenie na makietę {no} — {name}',
      emailHint: 'Wolisz e-mail? Też super — odpowiemy na pewno i będziemy mieć Twój właściwy adres.',
      guarT: 'Płacisz dopiero PO akceptacji makiety',
      guarD: 'Projektant najpierw pokaże cyfrowy projekt — poprawki są darmowe. Produkcja rusza dopiero po opłaceniu.',
      fineText: 'Zgłoszenie nic nie kosztuje i do niczego nie zobowiązuje. Zapłacisz dopiero wtedy, gdy zaakceptujesz makietę.',
      ctaSub: 'Złożysz sam albo zrobi projektant — u projektanta płacisz dopiero po akceptacji makiety',
      choiceSub: 'Cena i termin takie same. U projektanta płacisz dopiero po akceptacji makiety.',
      bullets: ['Kilka pytań — resztę robi projektant', 'Zdjęcia dodasz od razu w formularzu', 'Zapłacisz dopiero po akceptacji makiety'],
      guarantee: '🛡 Płacisz dopiero PO obejrzeniu makiety. Produkcja rusza po opłaceniu.'
    },
    en: {
      nameLbl: 'Your name',
      namePh: 'What should we call you?',
      contactLbl: 'Your contact',
      contactPh: 'Phone / @nick / e-mail',
      contactPhBy: { whatsapp: 'WhatsApp phone number, e.g. +48 600 000 000', instagram: 'Your Instagram @handle', messenger: 'Your name on Facebook', telegram: 'Phone or Telegram @handle', viber: 'Viber phone number' },
      emailLbl: 'Your e-mail',
      emailPh: 'e.g. anna@gmail.com',
      emailBad: 'Enter a valid e-mail address — the request cannot be sent without it.',
      emailHint: "Required — we'll send the mockup by e-mail if the messenger doesn't work.",
      photosLbl: 'Add photos right away',
      photosBtn: '📸 Choose photos',
      photosHint: "You can also send them later — we'll message you at the contact above.",
      consentTxt: 'I consent to the processing of my personal data and uploaded photos to prepare the mockup and contact me about this request.',
      consentLink: 'Privacy policy',
      submit: 'Send request',
      sending: 'Sending…',
      doneTitle: 'Request received! 🎉',
      doneText: 'The designer will prepare a mockup and send it to your contact. You only pay once you approve the mockup.',
      doneBtn: 'Great, waiting!',
      msgHeading: "Message us first — otherwise we can't reach you",
      msgWhy: "We'll send the mockup right in the messenger. Meta (Instagram, WhatsApp and Messenger) only lets businesses write to people who contacted them first — one message from you and the designer can send the mockup and ask about details.",
      msgBadge: 'No ads, no spam',
      msgPromise: 'We promise: we only write about your request.',
      btnWhatsapp: 'Message us on WhatsApp',
      btnInstagram: 'Message us on Instagram',
      btnMessenger: 'Message us on Messenger',
      bestBadge: 'Fastest reply',
      btnTelegram: 'Message us on Telegram',
      msgTemplate: 'Hello! My mockup request {no}. Name: {name}.',
      msgHint: 'Include your request number {no} (name: {name}) so we can find you right away.',
      photosSending: 'Uploading photos ({n}/{m})…',
      photosDone: 'Photos uploaded ✅',
      photosFail: "Some photos didn't upload — just send them in the messenger.",
      btnEmail: 'Write an e-mail',
      emailSubject: 'Mockup request {no} — {name}',
      emailHint: "Prefer e-mail? Works great too — we'll definitely reply and have your correct address.",
      guarT: 'You pay only AFTER approving the mockup',
      guarD: 'The designer shows a digital mockup first — revisions are free. Production starts once paid.',
      fineText: 'The request is free and non-binding. You pay only once you approve the mockup.',
      ctaSub: 'Build it yourself or let our designer — with the designer you pay only after approving the mockup',
      choiceSub: 'Same price, same lead time. With the designer you pay only after approving the mockup.',
      bullets: ['A few questions — the designer does the rest', 'Add photos right in the form', 'You pay only after approving the mockup'],
      guarantee: '🛡 You pay only AFTER seeing the mockup. Production starts once paid.'
    },
    uk: {
      nameLbl: "Ваше ім'я",
      namePh: 'Як до вас звертатись?',
      contactLbl: 'Ваш контакт',
      contactPh: 'Телефон / @нік / e-mail',
      contactPhBy: { whatsapp: 'Номер телефону з WhatsApp', instagram: 'Ваш @нік в Instagram', messenger: 'Імʼя у Facebook', telegram: 'Телефон або @нік у Telegram', viber: 'Номер телефону з Viber' },
      emailLbl: 'Ваш e-mail',
      emailPh: 'напр. anna@gmail.com',
      emailBad: 'Вкажіть коректний e-mail — без нього заявку не надіслати.',
      emailHint: 'Обовʼязково — на пошту надішлемо макет, якщо в месенджері не вийде.',
      photosLbl: 'Додайте фото одразу',
      photosBtn: '📸 Вибрати фото',
      photosHint: 'Можна й пізніше — ми напишемо вам на вказаний контакт.',
      consentTxt: 'Погоджуюсь на обробку моїх персональних даних і надісланих фото для підготовки макета та звʼязку щодо заявки.',
      consentLink: 'Політика конфіденційності',
      submit: 'Надіслати заявку',
      sending: 'Надсилаю…',
      doneTitle: 'Заявку прийнято! 🎉',
      doneText: 'Дизайнер підготує макет і надішле на вказаний контакт. Ви платите лише тоді, коли затвердите макет.',
      doneBtn: 'Супер, чекаю!',
      msgHeading: 'Напишіть нам першими — інакше ми не зможемо вам написати',
      msgWhy: 'Макет надішлемо саме в месенджер. Meta (Instagram) дозволяє бізнесу писати лише тим, хто написав першим — одне ваше повідомлення, і дизайнер зможе надіслати макет та уточнити деталі.',
      msgBadge: 'Без реклами і спаму',
      msgPromise: 'Обіцяємо: пишемо виключно щодо вашої заявки.',
      btnWhatsapp: 'Написати у WhatsApp',
      btnInstagram: 'Написати в Instagram',
      btnMessenger: 'Написати в Messenger',
      bestBadge: 'Тут відповідаємо найшвидше',
      btnTelegram: 'Написати в Telegram',
      msgTemplate: 'Доброго дня! Моя заявка на макет {no}. Імʼя: {name}.',
      msgHint: 'Назвіть номер заявки {no} (імʼя: {name}) — так ми одразу вас знайдемо.',
      photosSending: 'Надсилаємо фото ({n}/{m})…',
      photosDone: 'Фото надіслані ✅',
      photosFail: 'Не всі фото завантажились — просто надішліть їх у месенджер.',
      btnEmail: 'Написати на пошту',
      emailSubject: 'Заявка на макет {no} — {name}',
      emailHint: 'Зручніше поштою? Теж чудово — відповімо напевно, і у нас точно буде правильна адреса.',
      guarT: 'Оплата — лише ПІСЛЯ затвердження макета',
      guarD: 'Дизайнер спершу покаже цифровий макет — правки безкоштовні. Виробництво стартує після оплати.',
      fineText: 'Заявка нічого не коштує і ні до чого не зобовʼязує. Платите лише тоді, коли затвердите макет.',
      ctaSub: 'Зберете самі або зробить дизайнер — у дизайнера оплата лише після затвердження макета',
      choiceSub: 'Ціна і строк однакові. У дизайнера — оплата лише після затвердження макета.',
      bullets: ['Кілька питань — решту робить дизайнер', 'Фото додасте одразу у формі', 'Оплата — лише після затвердження макета'],
      guarantee: '🛡 Ви платите лише ПІСЛЯ перегляду макета. Виробництво стартує після оплати.'
    },
    /* 23.09.2026: без `ru` сторінки /ru падали на T.en — заявка показувалась англійською. */
    ru: {
      nameLbl: 'Ваше имя',
      namePh: 'Как к вам обращаться?',
      contactLbl: 'Ваш контакт',
      contactPh: 'Телефон / @ник / e-mail',
      contactPhBy: { whatsapp: 'Номер телефона с WhatsApp', instagram: 'Ваш @ник в Instagram', messenger: 'Имя в Facebook', telegram: 'Телефон или @ник в Telegram', viber: 'Номер телефона с Viber' },
      emailLbl: 'Ваш e-mail',
      emailPh: 'напр. anna@gmail.com',
      emailBad: 'Укажите корректный e-mail — без него заявку не отправить.',
      emailHint: 'Обязательно — на почту пришлём макет, если в мессенджере не получится.',
      photosLbl: 'Добавьте фото сразу',
      photosBtn: '📸 Выбрать фото',
      photosHint: 'Можно и позже — мы напишем вам на указанный контакт.',
      consentTxt: 'Соглашаюсь на обработку моих персональных данных и отправленных фото для подготовки макета и связи по заявке.',
      consentLink: 'Политика конфиденциальности',
      submit: 'Отправить заявку',
      sending: 'Отправляю…',
      doneTitle: 'Заявка принята! 🎉',
      doneText: 'Дизайнер подготовит макет и отправит на указанный контакт. Вы платите только тогда, когда утвердите макет.',
      doneBtn: 'Супер, жду!',
      msgHeading: 'Напишите нам первыми — иначе мы не сможем вам написать',
      msgWhy: 'Макет пришлём именно в мессенджер. Meta (Instagram) разрешает бизнесу писать только тем, кто написал первым — одно ваше сообщение, и дизайнер сможет отправить макет и уточнить детали.',
      msgBadge: 'Без рекламы и спама',
      msgPromise: 'Обещаем: пишем только по вашей заявке.',
      btnWhatsapp: 'Написать в WhatsApp',
      btnInstagram: 'Написать в Instagram',
      btnMessenger: 'Написать в Messenger',
      bestBadge: 'Здесь отвечаем быстрее всего',
      btnTelegram: 'Написать в Telegram',
      msgTemplate: 'Здравствуйте! Моя заявка на макет {no}. Имя: {name}.',
      msgHint: 'Назовите номер заявки {no} (имя: {name}) — так мы сразу вас найдём.',
      photosSending: 'Отправляем фото ({n}/{m})…',
      photosDone: 'Фото отправлены ✅',
      photosFail: 'Не все фото загрузились — просто отправьте их в мессенджер.',
      btnEmail: 'Написать на почту',
      emailSubject: 'Заявка на макет {no} — {name}',
      emailHint: 'Удобнее почтой? Тоже отлично — ответим наверняка, и у нас точно будет правильный адрес.',
      guarT: 'Оплата — только ПОСЛЕ утверждения макета',
      guarD: 'Дизайнер сначала покажет цифровой макет — правки бесплатные. Производство стартует после оплаты.',
      fineText: 'Заявка ничего не стоит и ни к чему не обязывает. Платите только тогда, когда утвердите макет.',
      ctaSub: 'Соберёте сами или сделает дизайнер — у дизайнера оплата только после утверждения макета',
      choiceSub: 'Цена и срок одинаковые. У дизайнера — оплата только после утверждения макета.',
      bullets: ['Несколько вопросов — остальное делает дизайнер', 'Фото добавите сразу в форме', 'Оплата — только после утверждения макета'],
      guarantee: '🛡 Вы платите только ПОСЛЕ просмотра макета. Производство стартует после оплаты.'
    }
  };

  var MAX_PHOTOS = 8;

  /* Канали «напишіть першими» по ринках. Дзеркалить thank-you-contact
     (shopify-account-previews/extensions/thank-you-contact/src/copy.js):
     PL — WhatsApp + Instagram kloniko.pl; UA WhatsApp не має — Telegram-бот
     підтримки + Instagram bricktopia.ua. wa.me приймає ?text= (передзаповнюємо
     імʼя з заявки), ig.me/t.me — ні, тому там просимо згадати імʼя текстом. */
  /* email — третій, спокійний канал: без обмеження Meta «клієнт пише першим»
     і з гарантовано правильною зворотною адресою. Тема/тіло передзаповнюються
     іменем із заявки (fillDoneContacts). */
  var CONTACTS = {
    pl: [
      /* Instagram — первым и с бейджем: у Direct окно ответа менеджера 7 дней,
         у WhatsApp — 24 ч. Messenger вместо почты (решение владельца 20.09.2026):
         m.me принимает ?text= так же, как wa.me; у страницы нет username — идём по ID. */
      { kind: 'instagram', url: 'https://ig.me/m/kloniko.pl', best: true },
      { kind: 'whatsapp', url: 'https://wa.me/48573458877', prefill: true },
      { kind: 'messenger', url: 'https://m.me/61585191122406', prefill: true }
    ],
    /* UA — свідомо без пошти (рішення власника): вся підтримка живе в
       Telegram/Instagram, поштова скринька для діалогів не моніториться. */
    ua: [
      { kind: 'telegram', url: 'https://t.me/BricktopiaSupUaBot' },
      { kind: 'instagram', url: 'https://ig.me/m/bricktopia.ua' }
    ]
  };

  function market(ctx) {
    return (ctx.submitBtn.getAttribute('data-socd-req-currency') || '') === 'PLN' ? 'pl' : 'ua';
  }

  /* Іконки месенджерів (стандартні гліфи, fill=currentColor). */
  var ICONS = {
    whatsapp: '<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.52.149-.174.198-.298.297-.497.1-.198.05-.371-.025-.52-.074-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>',
    telegram: '<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M11.944 0A12 12 0 000 12a12 12 0 0012 12 12 12 0 0012-12A12 12 0 0012 0a12 12 0 00-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 01.171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/></svg>',
    messenger: '<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 0C5.24 0 0 4.95 0 11.64c0 3.5 1.43 6.52 3.77 8.61.2.18.31.42.32.69l.07 2.13c.02.68.72 1.12 1.34.85l2.38-1.05c.2-.09.43-.1.64-.05 1.09.3 2.26.46 3.48.46 6.76 0 12-4.95 12-11.64S18.76 0 12 0zm7.2 8.96l-3.52 5.59c-.56.89-1.76 1.11-2.6.48l-2.8-2.1a.72.72 0 00-.87 0l-3.78 2.87c-.5.38-1.17-.22-.83-.76l3.52-5.59c.56-.89 1.76-1.11 2.6-.48l2.8 2.1c.26.19.61.19.87 0l3.78-2.87c.5-.38 1.17.22.83.76z"/></svg>',
    email: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="2" y="4" width="20" height="16" rx="3"/><path d="M3 6l9 7 9-7"/></svg>',
    instagram: '<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zm0 10.162a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>'
  };
  var BRAND = {
    whatsapp: 'background:#25D366',
    telegram: 'background:#229ED9',
    messenger: 'background:linear-gradient(45deg,#0099FF,#A033FF 60%,#FF5C87)',
    instagram: 'background:linear-gradient(45deg,#f09433,#e6683c,#dc2743,#cc2366,#bc1888)'
  };

  /* Пульс головної кнопки — щоб око само впало на «напишіть першими». */
  function injectStyleOnce() {
    if (document.getElementById('btreq-style')) return;
    var st = document.createElement('style');
    st.id = 'btreq-style';
    st.textContent =
      '@keyframes btreq-pulse-wa{0%{box-shadow:0 0 0 0 rgba(37,211,102,.55)}70%{box-shadow:0 0 0 13px rgba(37,211,102,0)}100%{box-shadow:0 0 0 0 rgba(37,211,102,0)}}' +
      '@keyframes btreq-pulse-tg{0%{box-shadow:0 0 0 0 rgba(34,158,217,.55)}70%{box-shadow:0 0 0 13px rgba(34,158,217,0)}100%{box-shadow:0 0 0 0 rgba(34,158,217,0)}}' +
      '.btreq-pulse-wa{animation:btreq-pulse-wa 1.8s ease-out infinite}' +
      '.btreq-pulse-tg{animation:btreq-pulse-tg 1.8s ease-out infinite}' +
      '@keyframes btreq-pulse-ig{0%{box-shadow:0 0 0 0 rgba(220,39,67,.55)}70%{box-shadow:0 0 0 13px rgba(220,39,67,0)}100%{box-shadow:0 0 0 0 rgba(220,39,67,0)}}' +
      '.btreq-pulse-ig{animation:btreq-pulse-ig 1.8s ease-out infinite}' +
      '.btreq-alert{display:flex;gap:10px;align-items:flex-start;margin:0 0 10px;padding:12px 14px;border-radius:14px;background:#fef2f2;border:2px solid #dc2626;color:#b91c1c;font-weight:800;font-size:16px;line-height:1.3}' +
      '.btreq-chan{position:relative}.btreq-chan svg{flex:none}' +
      /* Бейдж — наклейкой на углу: в строке он на телефоне выдавливал иконку. */
      '.btreq-best{position:absolute;top:-10px;right:18px;padding:3px 10px;border-radius:20px;background:#fff;color:#c2185b;border:1.5px solid #dc2743;font-size:11px;font-weight:800;line-height:1.2;white-space:nowrap;box-shadow:0 2px 6px rgba(0,0,0,.15)}';
    document.head.appendChild(st);
  }

  function texts(ctx) {
    var loc = (ctx.submitBtn.getAttribute('data-socd-locale') || '').toLowerCase();
    return T[loc] || T.en;
  }

  /* Ужимання фото: телефонні знімки по 5-10 МБ не пролазять у 4-МБ ліміт
     складового API. HEIC без canvas-підтримки летить як є — сервер приймає. */
  function shrinkPhoto(file) {
    return new Promise(function (resolve) {
      if (!/^image\//.test(file.type || '')) { resolve(null); return; }
      if (file.size <= 1.5 * 1024 * 1024) { resolve({ blob: file, name: file.name }); return; }
      var img = new Image();
      var url = URL.createObjectURL(file);
      img.onload = function () {
        try {
          var k = Math.min(1, 1800 / Math.max(img.width, img.height));
          var c = document.createElement('canvas');
          c.width = Math.round(img.width * k);
          c.height = Math.round(img.height * k);
          c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
          c.toBlob(function (b) {
            URL.revokeObjectURL(url);
            resolve(b ? { blob: b, name: (file.name || 'photo').replace(/\.\w+$/, '') + '.jpg' } : { blob: file, name: file.name });
          }, 'image/jpeg', 0.85);
        } catch (e) { URL.revokeObjectURL(url); resolve({ blob: file, name: file.name }); }
      };
      img.onerror = function () { URL.revokeObjectURL(url); resolve({ blob: file, name: file.name }); };
      img.src = url;
    });
  }

  /* ── UI: контакт + фото в кроці contact, фінальний екран ────────────────── */

  /* UA (07.10.2026, рішення власника): обовʼязковий контакт — номер телефону, e-mail — за бажанням.
     Склад окремого поля для телефону не має: номер іде рядком «Телефон» у бриф і, якщо контакт
     месенджера порожній, — у сам контакт. */
  var PHN = ({
    uk: { lbl: 'Ваш номер телефону', ph: '+380 67 000 00 00', bad: 'Вкажіть номер телефону — на нього напишемо щодо макета.', opt: '— за бажанням', mailHint: 'Можна залишити — макет продублюємо на пошту.', row: 'Телефон' },
    ru: { lbl: 'Ваш номер телефона', ph: '+380 67 000 00 00', bad: 'Укажите номер телефона — на него напишем по макету.', opt: '— по желанию', mailHint: 'Можно оставить — макет продублируем на почту.', row: 'Телефон' },
    en: { lbl: 'Your phone number', ph: '+380 67 000 00 00', bad: 'Enter your phone number — we will contact you about the mockup.', opt: '— optional', mailHint: 'Optional — we can also send the mockup by e-mail.', row: 'Phone' }
  })[(document.documentElement.lang || 'uk').slice(0, 2)] || null;
  function phoneDigits(v) { return String(v || '').replace(/\D/g, ''); }
  /* 24.10.2026 (власник: «всегда спрашивай два вида связи, потому что один может оказаться нерабочим»):
     крім телефону — ще один контакт: нік / номер у месенджері, що не повторює телефон, або пошта. */
  var C2 = ({
    uk: { opt: '— або нік у месенджері вище', err: 'Потрібен ще один контакт, крім телефону: нік у месенджері вище або пошта — раптом номер не відповідатиме.' },
    ru: { opt: '— или ник в мессенджере выше', err: 'Нужен ещё один контакт, кроме телефона: ник в мессенджере выше или почта — вдруг номер не ответит.' },
    en: { opt: '— or your messenger handle above', err: 'We need one more contact besides the phone: your messenger handle above or e-mail — in case the number does not answer.' }
  })[(document.documentElement.lang || 'uk').slice(0, 2)] || { opt: '', err: '' };
  function sameContact(a, b) {
    var da = phoneDigits(a), db = phoneDigits(b);
    if (da.length >= 9 && db.length >= 9 && !/[^\d\s()+\-.]/.test(String(a || '').trim())) return da.slice(-9) === db.slice(-9);
    return String(a || '').trim().toLowerCase() === String(b || '').trim().toLowerCase();
  }

  function injectContactUi(ctx, t) {
    var P = PHN || { lbl: 'Телефон', ph: '+380', bad: '', opt: '', mailHint: t.emailHint, row: 'Телефон' };
    var pane = ctx.overlay.querySelector('[data-socd-w="contact"]');
    if (!pane || pane.querySelector('[data-socd-contact-val]')) return;

    var lblEl = pane.querySelector('label');
    var labelCls = (lblEl || {}).className || '';
    /* Колір тексту беремо з ЖИВОГО label блока (socd__label-* = #111). Свої
       вставки без класу успадковували color від обгортки блока, а там на PL
       стоїть dsg_on_page_color:#fff — згода і підказка про фото були білим по
       білому в модалці (2026-09-07). */
    var txtCol = '#111';
    try {
      var _c = lblEl && getComputedStyle(lblEl).color;
      if (_c && _c !== 'rgba(0, 0, 0, 0)') txtCol = _c;
    } catch (e) {}
    var chipCls = (pane.querySelector('[data-socd-group="channel"] button') || {}).className || '';
    var nophoto = pane.querySelector('[class*="nophoto"]');
    if (nophoto) nophoto.style.display = 'none';

    /* 16px на інпутах — обовʼязково: менший шрифт iOS зумить (граблина блістера) */
    var inputCss = 'font-size:16px;width:100%;box-sizing:border-box;padding:12px 14px;border:1px solid rgba(0,0,0,.18);border-radius:10px;margin-top:6px';
    var host = document.createElement('div');
    host.innerHTML =
      '<label class="' + labelCls + '" style="margin-top:16px">' + t.nameLbl + '</label>' +
      '<input type="text" data-socd-contact-name placeholder="' + t.namePh.replace(/"/g, '&quot;') + '" autocomplete="name" style="' + inputCss + '">' +
      '<label class="' + labelCls + '" data-socd-contact-lbl style="margin-top:16px">' + t.contactLbl + '</label>' +
      '<input type="text" data-socd-contact-val placeholder="' + t.contactPh.replace(/"/g, '&quot;') + '" autocomplete="tel" style="' + inputCss + '">' +
      /* E-mail — ЗАВЖДИ обовʼязковий (рішення власника 20.09.2026): месенджер Meta
         закривається через 24 год / 7 днів, а пошта доходить завжди. */
      '<label class="' + labelCls + '" style="margin-top:16px">' + P.lbl + ' <span style="color:#dc2626">*</span></label>' +
      '<input type="tel" data-socd-contact-phone required placeholder="' + P.ph + '" autocomplete="tel" inputmode="tel" style="' + inputCss + '">' +
      '<div data-socd-phone-err style="display:none;margin-top:6px;font-size:13px;font-weight:700;color:#dc2626">' + P.bad + '</div>' +
      '<label class="' + labelCls + '" style="margin-top:16px">' + t.emailLbl + ' <span style="font-weight:400;opacity:.6">' + (C2.opt || P.opt) + '</span></label>' +
      '<input type="email" data-socd-contact-email placeholder="' + t.emailPh.replace(/"/g, '&quot;') + '" autocomplete="email" inputmode="email" style="' + inputCss + '">' +
      '<div style="margin-top:6px;font-size:12px;opacity:.65;color:' + txtCol + '">' + P.mailHint + '</div>' +
      '<div data-socd-email-err style="display:none;margin-top:6px;font-size:13px;font-weight:700;color:#dc2626">' + t.emailBad + '</div>' +
      '<div data-socd-c2-err style="display:none;margin-top:6px;font-size:13px;font-weight:700;color:#dc2626">' + C2.err + '</div>' +
      '<label class="' + labelCls + '" style="margin-top:16px">' + t.photosLbl + '</label>' +
      '<input type="file" data-socd-photo-input accept="image/*" multiple style="display:none">' +
      '<button type="button" class="' + chipCls + '" data-socd-photo-btn>' + t.photosBtn + '</button>' +
      '<div data-socd-photo-list style="display:flex;gap:8px;flex-wrap:wrap;margin-top:10px"></div>' +
      '<div style="margin-top:8px;font-size:12px;opacity:.65;color:' + txtCol + '">' + t.photosHint + '</div>' +
      /* RODO/GDPR: обробка даних і фото — обовʼязкова згода, без неї «Далі»
         не вмикається (validContact). Факт згоди їде в заявку (contact.consent). */
      '<label style="display:flex;gap:10px;align-items:flex-start;margin-top:14px;font-size:12px;line-height:1.45;opacity:.85;cursor:pointer;color:' + txtCol + '">' +
        '<input type="checkbox" data-socd-consent style="margin-top:2px;width:16px;height:16px;flex:none">' +
        '<span>' + t.consentTxt + ' <a href="/policies/privacy-policy" target="_blank" rel="noopener" style="text-decoration:underline;color:inherit">' + t.consentLink + '</a></span>' +
      '</label>';

    /* Перед підсумком: останній label у панелі — «Ваше замовлення». */
    var labels = pane.querySelectorAll('label');
    var sumLabel = labels.length ? labels[labels.length - 1] : null;
    while (host.firstChild) pane.insertBefore(host.firstChild, sumLabel);

    ctx.contactEl = pane.querySelector('[data-socd-contact-val]');
    ctx.nameEl = pane.querySelector('[data-socd-contact-name]');
    ctx.contactEl.addEventListener('input', function () { ctx.h.renderNav(); });
    ctx.nameEl.addEventListener('input', function () { ctx.h.renderNav(); });
    /* paneValid блока питає нас: заявка валідна лише з імʼям і контактом. */
    ctx.consentEl = pane.querySelector('[data-socd-consent]');
    ctx.consentEl.addEventListener('change', function () { ctx.h.renderNav(); });
    ctx.emailEl = pane.querySelector('[data-socd-contact-email]');
    /* Визначаємо ДО будь-яких викликів renderNav: якщо той кине виняток до
       відкриття майстра, validContact усе одно має існувати — інакше заявку
       неможливо надіслати. */
    ctx.emailOk = function () { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(ctx.emailEl.value.trim()); };
    ctx.phoneEl = pane.querySelector('[data-socd-contact-phone]');
    ctx.phoneOk = function () { var d = phoneDigits(ctx.phoneEl && ctx.phoneEl.value); return d.length >= 10 && d.length <= 15; };
    /* Другий контакт: пошта або месенджер, що не повторює телефон (канал «Email» — сама пошта). */
    ctx.secondOk = function () {
      if (ctx.channelKind && ctx.channelKind() === 'email') return ctx.emailOk();
      var v = ctx.contactEl.value.trim();
      return ctx.emailOk() || (v.length >= 3 && !sameContact(v, ctx.phoneEl.value));
    };
    ctx.validContact = function () {
      var isMail = ctx.channelKind && ctx.channelKind() === 'email';
      var mailFilled = ctx.emailEl.value.trim() !== '';
      /* Телефон — обовʼязковий; пошта — лише якщо вписана (тоді має бути коректна) або якщо канал «Email». */
      var mailOk = isMail ? ctx.emailOk() : (!mailFilled || ctx.emailOk());
      return !!(ctx.nameEl.value.trim() && ctx.phoneOk() && mailOk && ctx.secondOk() && ctx.consentEl.checked);
    };
    var phoneErr = pane.querySelector('[data-socd-phone-err]');
    function markPhone(force) {
      var bad = !ctx.phoneOk() && (force || ctx.phoneEl.value.trim() !== '');
      ctx.phoneEl.style.borderColor = bad ? '#dc2626' : 'rgba(0,0,0,.18)';
      if (phoneErr) phoneErr.style.display = bad ? '' : 'none';
    }
    ctx.phoneEl.addEventListener('input', function () { if (ctx.phoneOk()) markPhone(false); ctx.h.renderNav(); });
    ctx.phoneEl.addEventListener('blur', function () { markPhone(true); });
    /* Кнопка «далі» без пошти просто сіра — пояснюємо чому, щойно людина пішла з поля. */
    var emailErr = pane.querySelector('[data-socd-email-err]');
    function markEmail(force) {
      var bad = ctx.emailEl.value.trim() !== '' && !ctx.emailOk();
      ctx.emailEl.style.borderColor = bad ? '#dc2626' : 'rgba(0,0,0,.18)';
      if (emailErr) emailErr.style.display = bad ? '' : 'none';
    }
    ctx.emailEl.addEventListener('input', function () { if (ctx.emailOk()) markEmail(false); ctx.h.renderNav(); });
    ctx.emailEl.addEventListener('blur', function () { markEmail(true); });
    /* Кнопка «далі» сіра без другого контакту — пояснюємо, щойно телефон уже є, а людина пішла з поля. */
    var c2Err = pane.querySelector('[data-socd-c2-err]');
    function markSecond(force) {
      if (!c2Err) return;
      var bad = force && ctx.phoneOk() && !ctx.secondOk();
      if (bad || ctx.secondOk()) c2Err.style.display = bad ? '' : 'none';
    }
    [ctx.emailEl, ctx.phoneEl, ctx.contactEl].forEach(function (el) {
      el.addEventListener('blur', function () { markSecond(true); });
      el.addEventListener('input', function () { markSecond(false); try { ctx.h.renderNav(); } catch (e) {} });
    });
    /* Канал «Email»: окреме поле «контакт» зайве — контактом стає сама пошта.
       Для месенджерів — підказка саме під обраний канал. */
    var contactLblEl = pane.querySelector('[data-socd-contact-lbl]');
    var chipsEl = pane.querySelector('[data-socd-group="channel"]');
    /* Обраний чип запамʼятовуємо самі з кліку: на клас «активного» чипа блока
       покладатися не можна (перевірено на живій сторінці — клас не ставиться
       до відкриття кроку). До першого кліку активний перший чип (pickDefaults). */
    var pickedChip = null;
    ctx.channelKind = function () {
      var on = pickedChip || (chipsEl && (chipsEl.querySelector('.is-on') || chipsEl.querySelector('button')));
      var v = ((on && on.getAttribute('data-socd-val')) || '').toLowerCase();
      return /mail/.test(v) ? 'email' : v;
    };
    function syncChannel() {
      var kind = ctx.channelKind();
      var isMail = kind === 'email';
      ctx.contactEl.style.display = isMail ? 'none' : '';
      if (contactLblEl) contactLblEl.style.display = isMail ? 'none' : '';
      ctx.contactEl.placeholder = (t.contactPhBy && t.contactPhBy[kind]) || t.contactPh;
      try { ctx.h.renderNav(); } catch (e) {}
    }
    if (chipsEl) chipsEl.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('button[data-socd-val]') : null;
      if (b) pickedChip = b;
      setTimeout(syncChannel, 0);
    });
    syncChannel();

    var photoInput = pane.querySelector('[data-socd-photo-input]');
    var photoBtn = pane.querySelector('[data-socd-photo-btn]');
    var photoList = pane.querySelector('[data-socd-photo-list]');
    ctx.photos = [];

    function renderPhotos() {
      photoList.innerHTML = '';
      ctx.photos.forEach(function (p, i) {
        var w = document.createElement('div');
        w.style.cssText = 'position:relative;width:64px;height:64px';
        var im = document.createElement('img');
        im.src = p.url;
        im.style.cssText = 'width:64px;height:64px;object-fit:cover;border-radius:10px;display:block';
        var x = document.createElement('button');
        x.type = 'button';
        x.textContent = '✕';
        x.style.cssText = 'position:absolute;top:-6px;right:-6px;width:20px;height:20px;border-radius:50%;border:none;background:#1a1a1a;color:#fff;font-size:11px;line-height:20px;padding:0;cursor:pointer';
        x.addEventListener('click', function () {
          URL.revokeObjectURL(p.url);
          ctx.photos.splice(i, 1);
          renderPhotos();
        });
        w.appendChild(im); w.appendChild(x);
        photoList.appendChild(w);
      });
    }

    photoBtn.addEventListener('click', function () { photoInput.click(); });
    photoInput.addEventListener('change', function () {
      var files = Array.prototype.slice.call(photoInput.files || []);
      photoInput.value = '';
      files.slice(0, MAX_PHOTOS - ctx.photos.length).forEach(function (f) {
        shrinkPhoto(f).then(function (p) {
          if (!p || ctx.photos.length >= MAX_PHOTOS) return;
          p.url = URL.createObjectURL(p.blob);
          ctx.photos.push(p);
          renderPhotos();
        });
      });
    });
  }

  function injectDoneStep(ctx, t) {
    if (ctx.overlay.querySelector('[data-socd-step="reqdone"]')) return;
    var brief = ctx.overlay.querySelector('[data-socd-step="brief"]');
    if (!brief) return;
    var head = brief.querySelector('[class*="head"]');
    var title = brief.querySelector('h3');
    var sub = brief.querySelector('p');

    /* Картка «напишіть нам першими» — у РІДНОМУ стилі візарда: клас зеленої
       «гарантійної» плашки (socd__guar*) + pill-кнопки socd__pgo. Класи
       беремо з живих елементів (вони uid-суфіксовані). Плейсхолдер {name}
       заповнюється після сабміту (fillDoneContacts) — на init імені ще нема. */
    var guar = ctx.overlay.querySelector('[data-socd-guar]');
    function gcls(sub) {
      var e = guar && guar.querySelector('[class*="' + sub + '"]');
      return e ? e.className : '';
    }
    var cardCls = guar ? guar.className : '';
    /* Гарантійну плашку мерчант може вимкнути (dsg_guar_t порожній) — тоді
       класів нема, і картка отримує той самий вигляд інлайном. */
    var cardFallback = cardCls ? '' : ';position:relative;margin-top:14px;border-radius:18px;padding:14px 16px;background:#f0fdf4;border:2px solid #86efac;color:#14532d';
    injectStyleOnce();
    /* Кнопки каналів — у фірмових кольорах месенджерів з іконками: людина
       має за секунду впізнати «свій» застосунок. Перша — з пульсом. */
    var chans = CONTACTS[market(ctx)] || [];
    var LBL = { whatsapp: t.btnWhatsapp, telegram: t.btnTelegram, instagram: t.btnInstagram, messenger: t.btnMessenger, email: t.btnEmail };
    var btnsHtml = chans.map(function (c, i) {
      var pulse = i === 0 ? ({ telegram: ' btreq-pulse-tg', instagram: ' btreq-pulse-ig' }[c.kind] || ' btreq-pulse-wa') : '';
      var base = 'display:flex;align-items:center;justify-content:center;gap:10px;box-sizing:border-box;width:100%;padding:14px 16px;border-radius:50px;font-weight:800;font-size:15px;text-decoration:none;margin-top:' + (i === 0 ? '14px' : '9px') + ';';
      /* email — навмисно спокійний (обводка, не бренд-колір): месенджери
         першими, пошта — для тих, кому так звичніше. */
      var style = c.kind === 'email'
        ? base + 'background:#fff;color:#1a1a1a;border:1.5px solid rgba(0,0,0,.25)'
        : base + 'color:#fff;' + (BRAND[c.kind] || 'background:#1a1a1a');
      var href = c.kind === 'email' ? 'mailto:' + c.email : c.url;
      return '<a class="btreq-chan' + pulse + '" data-socd-req-chan="' + c.kind + '" href="' + href + '" target="_blank" rel="noopener noreferrer" style="' + style + '">' + (ICONS[c.kind] || '') + '<span>' + (LBL[c.kind] || '') + '</span>' + (c.best && t.bestBadge ? '<span class="btreq-best">' + t.bestBadge + '</span>' : '') + '</a>';
    }).join('');

    var step = document.createElement('div');
    step.className = brief.className.replace(/\bis-active\b/, '').trim();
    step.setAttribute('data-socd-step', 'reqdone');
    step.innerHTML =
      '<div class="' + ((head && head.className) || '') + '" style="text-align:center;padding-top:30px">' +
        '<h3 class="' + ((title && title.className) || '') + '">' + t.doneTitle + '</h3>' +
        '<p class="' + ((sub && sub.className) || '') + '" style="max-width:440px;margin-left:auto;margin-right:auto">' + t.doneText + '</p>' +
      '</div>' +
      '<div style="padding:0 24px 30px;max-width:500px;margin:0 auto;box-sizing:border-box">' +
        /* padding-left:16px перебиває 56px гарантійної плашки: її круглий
           значок ми НЕ рендеримо (на високій картці він висів посередині
           лівого краю і ламав вигляд), тож і кишеня під нього не потрібна. */
        '<div class="' + cardCls + '" style="display:block;text-align:left;padding-left:16px' + cardFallback + '">' +
          /* Красный блок: без сообщения от клиента мы физически не можем
             написать — это главное действие экрана, зелёная карточка его прятала. */
          '<div class="btreq-alert"><span aria-hidden="true" style="flex:none;font-size:20px;line-height:1.1">⚠️</span><span>' + t.msgHeading + '</span></div>' +
          '<div class="' + gcls('guard') + '">' + t.msgWhy + ' <b>' + t.msgBadge + '.</b> ' + t.msgPromise + '</div>' +
          btnsHtml +
          (chans.some(function (c) { return c.kind === 'email'; })
            ? '<div class="' + gcls('guard') + '" style="margin-top:8px">' + t.emailHint + '</div>'
            : '') +
          '<div class="' + gcls('guard') + '" data-socd-req-hint style="margin-top:4px"></div>' +
          '<div class="' + gcls('guard') + '" data-socd-req-photostat style="margin-top:2px;font-weight:700"></div>' +
        '</div>' +
      '</div>';
    brief.parentNode.appendChild(step);
  }

  /* Після сабміту знаємо імʼя і номер заявки — підставляємо в передзаповнені
     повідомлення/тему листа і в хінт. Номер («#12») — головний ключ пошуку
     менеджера у вкладці «Заявки на макет». */
  function fillTpl(tpl, name, no) {
    var out = tpl.split('{name}').join(name);
    out = out.split('{no}').join(no ? '#' + no : '');
    return out.replace(/\s{2,}/g, ' ').replace(/\s+([.,)])/g, '$1');
  }
  function fillDoneContacts(ctx, t, name, no) {
    var step = ctx.overlay.querySelector('[data-socd-step="reqdone"]');
    if (!step) return;
    var chans = CONTACTS[market(ctx)] || [];
    var msg = fillTpl(t.msgTemplate, name, no);
    chans.forEach(function (c) {
      var a = step.querySelector('[data-socd-req-chan="' + c.kind + '"]');
      if (!a) return;
      if (c.prefill) a.href = c.url + '?text=' + encodeURIComponent(msg);
      if (c.kind === 'email') {
        a.href = 'mailto:' + c.email +
          '?subject=' + encodeURIComponent(fillTpl(t.emailSubject, name, no)) +
          '&body=' + encodeURIComponent(msg);
      }
    });
    var hint = step.querySelector('[data-socd-req-hint]');
    if (hint) hint.textContent = fillTpl(t.msgHint, name, no);
  }

  /* Буллети й гарантія картки «Хай зробить дизайнер» на екрані вибору —
     чесні «оплата після макета» (мерчант міг вписати свої в налаштуваннях
     блока — тоді підміну робити не можна: атрибут data-socd-req-owntexts). */
  function swapChoiceTexts(ctx, t) {
    if (ctx.submitBtn.getAttribute('data-socd-req-owntexts') === '1') return;
    var card = ctx.overlay.querySelector('[data-socd-go="designer"]');
    if (!card) return;
    var ul = card.querySelector('ul');
    if (ul) ul.innerHTML = t.bullets.map(function (b) { return '<li>' + b + '</li>'; }).join('');
    var guar = card.querySelector('[class*="pguar"]');
    if (guar) guar.textContent = t.guarantee;
  }

  /* ── Заявка ─────────────────────────────────────────────────────────────── */

  /* Позиції ті САМІ, що збирає cartLines блока (лінія на тип за базовою ціною;
     рамка — одна лінія за повну суму), але без variant-lookup. Знижку за
     кількість Shopify поза кошиком не нарахує — шлемо totals().save окремо. */
  function requestLines(ctx) {
    var st = ctx.state();
    var title = ctx.submitBtn.getAttribute('data-socd-product-title') || 'Design';
    if (ctx.frameMode) {
      var ft = ctx.h.totals().total;
      if (!(ft > 0)) return null;
      var sz = ctx.h.activeSize();
      return { lines: [{ title: title + (sz ? ' — ' + sz.replace('x', '×') : ''), qty: 1, price: ft }], discount: 0 };
    }
    var counts = {}, order = [], i;
    for (i = 0; i < st.slots.length; i++) {
      if (!counts[st.slots[i]]) { counts[st.slots[i]] = 0; order.push(st.slots[i]); }
      counts[st.slots[i]]++;
    }
    if (!st.framePrices) {
      /* Прайс не відповів — одна позиція за рекламованою ціною картки. */
      var p = ctx.h.parsePriceText(st.picked.price || ctx.submitBtn.getAttribute('data-socd-price') || '');
      if (!(p > 0)) return null;
      return { lines: [{ title: title, qty: 1, price: p }], discount: 0 };
    }
    var out = [], L = ctx.L;
    for (i = 0; i < order.length; i++) {
      var t2 = order[i], pr = ctx.h.typePrice(t2);
      if (!(pr > 0)) return null;
      var lbl = t2 === 'animal' ? (L.tAnimal || 'animal') : (t2 === 'baby' ? (L.tBaby || 'baby') : (L.tHuman || 'figure'));
      out.push({ title: title + ' — ' + lbl, qty: counts[t2], price: pr });
    }
    var tt = ctx.h.totals();
    return { lines: out, discount: (tt.save > 0 ? tt.save : 0) };
  }

  /* Фото — У ФОНІ, вже ПІСЛЯ екрана «прийнято»: бриф і контакт — головне, і
     вони вже на складі. Послідовно, по одній спробі-повтору, 20с таймауту на
     фото (без нього завислий аплоад крутив би статус вічно). Прогрес і
     підсумок пишемо в рядок на картці; про недолиті фото чесно кажемо
     «надішліть у месенджер» — дизайнер там і так відповість. */
  function uploadPhotosBg(ctx, id, t) {
    var photos = ctx.photos || [];
    if (!photos.length) return;
    var stat = ctx.overlay.querySelector('[data-socd-req-photostat]');
    function setStat(txt) { if (stat) stat.textContent = txt; }
    var failed = 0;

    function one(p, attempt) {
      var fd = new FormData();
      fd.append('photo', p.blob, p.name || 'photo.jpg');
      var ac = (typeof AbortController !== 'undefined') ? new AbortController() : null;
      var timer = ac ? setTimeout(function () { ac.abort(); }, 20000) : null;
      return fetch(ctx.api + '/photo?id=' + encodeURIComponent(id), {
        method: 'POST', body: fd, signal: ac ? ac.signal : undefined
      })
        .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); })
        .catch(function () {
          if (attempt < 1) return one(p, attempt + 1);
          failed++;
        })
        .then(function () { if (timer) clearTimeout(timer); });
    }

    var chain = Promise.resolve();
    photos.forEach(function (p, i) {
      chain = chain.then(function () {
        setStat(t.photosSending.replace('{n}', String(i + 1)).replace('{m}', String(photos.length)));
        return one(p, 0);
      });
    });
    chain.then(function () { setStat(failed ? t.photosFail : t.photosDone); });
  }

  /* ── Джерело заявки і конверсія Google Ads (10.10.2026) ───────────────────
     attribution: перший/останній дотик за 90 днів (utm, click-id, referrer,
     сторінка входу). UA — window.btAttribution (snippets/bt-attribution.liquid),
     PL — той самий ключ localStorage пише assets/bt-lead.js. На відміну від
     sourceUrl не губиться, коли покупець пішов зі сторінки входу; склад кладе
     його в design_requests.attribution (статистика «Звідки прийшли»).
     Без згоди на маркетингові cookies click-id (gclid/fbclid/…) замінюємо на
     '1': канал видно, ідентифікатора кліку немає. */
  var ATTR_KEY = 'bt_attr_v1';
  var ATTR_TTL = 90 * 24 * 3600 * 1000;
  var CLICK_IDS = ['gclid', 'gbraid', 'wbraid', 'fbclid', 'ttclid'];

  function marketingAllowed() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      return !!(cp && typeof cp.marketingAllowed === 'function' && cp.marketingAllowed());
    } catch (e) { return false; }
  }

  function readAttribution() {
    var a = null;
    try {
      if (window.btAttribution && typeof window.btAttribution.get === 'function') a = window.btAttribution.get();
      else {
        a = JSON.parse(localStorage.getItem(ATTR_KEY) || 'null');
        if (a && a.first && Date.now() - a.first.ts > ATTR_TTL) a = null;
      }
    } catch (e) { a = null; }
    return a && typeof a === 'object' ? a : {};
  }

  function requestAttribution() {
    var a = readAttribution();
    if (marketingAllowed()) return a;
    var out = {};
    ['first', 'last'].forEach(function (k) {
      var t = a[k];
      if (!t || typeof t !== 'object') return;
      var c = {};
      for (var p in t) if (Object.prototype.hasOwnProperty.call(t, p)) c[p] = CLICK_IDS.indexOf(p) >= 0 ? '1' : t[p];
      out[k] = c;
    });
    return out;
  }

  /* Google Ads: окремі дії-конверсії «Zgłoszenie do projektanta — ramka / figurka»
     (Secondary) — тип заявки в Google Ads видно лише як окрему дію.
     Теги Google на вітрині ставить застосунок Google & YouTube у пісочниці web
     pixels — window.gtag на сторінці НЕМАЄ (як і fbq, див. bt-socd-designer.js).
     Тому gtag.js вантажимо самі, ЛИШЕ в момент успішної заявки і лише за згоди
     на маркетингові cookies, без page_view. Purchase тут не шлеться ніколи —
     його шле застосунок, дубля немає. Custom pixel не підходить: він живе в
     iframe без доступу до cookies, тож Google не бачить gclid.
     Мітка порожня → подія в Google не йде (лише Shopify.analytics.publish).
     Мітки — з дій-конверсій в акаунтах 473-074-6141 (PL, Kloniko) і
     946-425-2344 (UA, Bricktopia); ключ — валюта магазину, далі productType
     заявки (невідомий тип іде як mini). */
  var GADS = {
    PLN: { id: 'AW-18440922536', labels: { frame: '4-jGCOLY65cdEKjLqNlE', mini: 'HwT1COXY65cdEKjLqNlE' } },
    UAH: { id: 'AW-18505501771', labels: { frame: 'U8UtCOWNkJgdEMuYjvhE', mini: 'adGECOiNkJgdEMuYjvhE' } }
  };
  /* Цінність заявки = сума × частка оплачених (PL, 24.09–09.10.2026:
     рамка 21 з 68, фігурки 13 з 46). */
  var GADS_PAY_RATE = 0.3;
  var gadsLoaded = false;

  function cookie(n) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + n + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }

  /* gtag бере gclid з cookie _gcl_aw, яку пише сам на сторінці входу. Наш gtag
     там не працює, тому, якщо cookie немає, відновлюємо її з дотику (той самий
     формат GCL.<сек>.<gclid>, строк — як у Google, 90 днів від кліку). */
  function restoreGclid(attr) {
    if (cookie('_gcl_aw')) return;
    var t = [attr.last, attr.first].filter(function (x) { return x && typeof x.gclid === 'string' && x.gclid.length > 8; })[0];
    if (!t) return;
    var left = Math.floor((Number(t.ts) + ATTR_TTL - Date.now()) / 1000);
    if (!(left > 0)) return;
    var host = location.hostname.replace(/^www\./, '');
    document.cookie = '_gcl_aw=GCL.' + Math.floor(Number(t.ts) / 1000) + '.' + encodeURIComponent(t.gclid) +
      '; max-age=' + left + '; path=/; domain=.' + host + '; SameSite=Lax; Secure';
  }

  function trackRequest(payload, d) {
    var total = payload.lines.reduce(function (s, l) { return s + l.price * l.qty; }, 0) - (payload.discount || 0);
    total = Math.round(total * 100) / 100;
    /* Для custom pixel (GA4 тощо). ⚠ Не підписувати на цю подію ще й Google Ads —
       буде дубль із gtag нижче. */
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('design_request_submitted', {
          request_id: d.id, request_no: d.no || 0, product_type: payload.productType,
          value: total, currency: payload.currency || ''
        });
      }
    } catch (e) { /* ignore */ }

    var g = GADS[payload.currency];
    var label = g && (g.labels[payload.productType] || g.labels.mini);
    if (!label || !marketingAllowed()) return;
    try {
      restoreGclid(readAttribution());
      window.dataLayer = window.dataLayer || [];
      if (typeof window.gtag !== 'function') window.gtag = function () { window.dataLayer.push(arguments); };
      if (!gadsLoaded) {
        gadsLoaded = true;
        var cp = window.Shopify.customerPrivacy;
        var an = typeof cp.analyticsProcessingAllowed === 'function' && cp.analyticsProcessingAllowed();
        window.gtag('consent', 'default', {
          ad_storage: 'granted', ad_user_data: 'granted', ad_personalization: 'granted',
          analytics_storage: an ? 'granted' : 'denied'
        });
        window.gtag('js', new Date());
        window.gtag('config', g.id, { send_page_view: false });
        var s = document.createElement('script');
        s.async = true;
        s.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(g.id);
        document.head.appendChild(s);
      }
      window.gtag('event', 'conversion', {
        send_to: g.id + '/' + label,
        value: Math.round(total * GADS_PAY_RATE * 100) / 100,
        currency: payload.currency,
        transaction_id: 'dreq_' + d.id
      });
    } catch (e) { /* ignore */ }
  }

  function submit(ctx) {
    var st = ctx.state();
    var L = ctx.L, h = ctx.h, els = ctx.els();
    if (ctx.frameMode && !h.activeSize()) return;
    if (!st.picked.deadline || !h.paneValid()) return;

    var composition = {}, i;
    for (i = 0; i < st.slots.length; i++) composition[st.slots[i]] = (composition[st.slots[i]] || 0) + 1;

    /* Людські рядки — той самий набір, що props кошикового doSubmit. */
    var rows = [];
    function row(l, v) { if (l && v) rows.push({ label: l, value: String(v) }); }
    row(L.mode || 'Design', L.modeVal || 'Designer');
    row(L.qty || 'Qty', h.composeText());
    if (st.picked.keychainLabel) row(L.keychain || 'Type', st.picked.keychainLabel);
    if (ctx.frameMode) {
      row(L.figs || 'Figures', String(st.slots.length));
      if (h.activeSize()) row(L.size || 'Size', h.activeSize().replace('x', '×'));
      row(L.propFcolor || 'Frame colour', h.swLabel('fcolor', st.wiz.fcolor));
      row(L.propBrick || 'Brick colour', h.swLabel('brick', st.wiz.brick));
      if (h.bgText()) row(L.propBg || 'Background', h.bgText());
      if (els.signEl && els.signEl.value.trim()) row(L.propSign || 'Caption', els.signEl.value.trim().slice(0, 200));
    }
    row(L.deadline || 'Deadline', h.deadlineText());
    if (h.occText()) row(L.occasion || 'Occasion', h.occText());
    if (els.wishesEl && els.wishesEl.value.trim()) row(L.wishes || 'Wishes', els.wishesEl.value.trim().slice(0, 900));
    var contactEmail = ctx.emailEl ? ctx.emailEl.value.trim().slice(0, 200) : '';
    var contactVal = ctx.contactEl ? ctx.contactEl.value.trim().slice(0, 200) : '';
    if (ctx.channelKind && ctx.channelKind() === 'email') contactVal = contactEmail;
    var contactName = ctx.nameEl ? ctx.nameEl.value.trim().slice(0, 120) : '';
    var contactPhone = ctx.phoneEl ? ctx.phoneEl.value.trim().slice(0, 40) : '';
    if (!contactVal && contactPhone) contactVal = contactPhone;
    if (contactPhone) row((PHN && PHN.row) || 'Телефон', contactPhone);
    row(L.channel || 'Contact', (contactName ? contactName + ' · ' : '') + (st.picked.channel || '') + (contactVal ? ' — ' + contactVal : '') + (contactEmail && contactEmail !== contactVal ? ' · ' + contactEmail : ''));

    /* Машинний бриф — той самий JSON, що їде в _bt_designer_brief. */
    var brief = {
      qty: String(st.slots.length),
      composition: composition,
      figures: ctx.frameMode ? String(st.slots.length) : null,
      size: ctx.frameMode ? h.activeSize() : null,
      frame_color: ctx.frameMode ? st.wiz.fcolor : null,
      brick_color: ctx.frameMode ? st.wiz.brick : null,
      background: ctx.frameMode ? (h.bgText() || null) : null,
      signature: (ctx.frameMode && els.signEl && els.signEl.value.trim().slice(0, 200)) || '',
      deadline: st.picked.deadline,
      keychain: st.picked.keychain ? st.picked.keychain === 'yes' : null,
      deadline_date: (els.dateInput && els.dateInput.value) || '',
      occasion: h.occText(), channel: st.picked.channel,
      wishes: (els.wishesEl && els.wishesEl.value.trim().slice(0, 900)) || ''
    };

    var rl = requestLines(ctx);
    if (!rl) { h.fail(); return; }

    var payload = {
      locale: ctx.submitBtn.getAttribute('data-socd-locale') || '',
      sourceUrl: location.href.slice(0, 300),
      attribution: requestAttribution(),
      productType: ctx.frameMode ? 'frame' : (ctx.submitBtn.getAttribute('data-socd-product-type') || 'mini'),
      contact: { channel: st.picked.channel || '', value: contactVal, email: contactEmail, name: contactName, consent: !!(ctx.consentEl && ctx.consentEl.checked) },
      brief: brief,
      briefRows: rows,
      lines: rl.lines,
      discount: rl.discount,
      currency: ctx.submitBtn.getAttribute('data-socd-req-currency') || '',
      photosCount: (ctx.photos || []).length
    };

    h.setBusy(true);
    if (ctx.errEl) ctx.errEl.classList.remove('is-on');

    h.withRetry('request', 3, function () {
      return fetch(ctx.api, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (r) {
        if (r.ok) return r.json();
        return r.json().catch(function () { return {}; }).then(function (b) {
          var e = new Error('HTTP ' + r.status + (b && b.error ? ' — ' + String(b.error).slice(0, 180) : ''));
          if (r.status < 500) e.__noRetry = true; /* 4xx = зрозумів і відмовив */
          return Promise.reject(e);
        });
      });
    })
      .then(function (d) {
        if (!d || !d.ok || !d.id) return Promise.reject(new Error('bad response'));
        /* Meta Lead: без нього реклама не бачить цих конверсій і не вчиться
           на них (Purchase прилетить лише коли менеджер оформить замовлення).
           eventID = id заявки — якщо колись додамо серверний CAPI-Lead,
           дедуп уже готовий. Best-effort: піксель заблокований — не наша біда. */
        try {
          if (typeof window.fbq === 'function') {
            var leadValue = payload.lines.reduce(function (s, l) { return s + l.price * l.qty; }, 0) - (payload.discount || 0);
            window.fbq('track', 'Lead', {
              content_name: 'designer-mockup-request',
              content_category: payload.productType,
              value: Math.round(leadValue * 100) / 100,
              currency: payload.currency || undefined
            }, { eventID: 'dreq_' + d.id });
          }
        } catch (e) { /* ignore */ }
        trackRequest(payload, d);
        /* «Прийнято» показуємо ОДРАЗУ — фото довантажуються фоном і не можуть
           ні затримати, ні завалити підтвердження. */
        h.setBusy(false);
        var t = texts(ctx);
        fillDoneContacts(ctx, t, contactName, d.no || 0);
        h.showStep('reqdone');
        /* «Звідки ви про нас дізнались?» — картка після заявки (assets/bt-heard.js, 02.11.2026) */
        try { if (window.btHeard) window.btHeard.ask({ type: 'design', id: d.id, api: ctx.api }); } catch (e) { /* ignore */ }
        uploadPhotosBg(ctx, d.id, t);
      })
      .catch(function (err) {
        h.reportFailure(err);
        h.fail();
      });
  }

  /* «Оплата після макета» — ще ДО попапа: підпис під головною CTA картки
     і підзаголовок екрана вибору. Люди мають знати умову до кліку, а не
     дізнаватись на останньому кроці. Класи uid-суфіксовані — uid тягнемо
     з className оверлея. */
  function honestSubLines(ctx, t) {
    if (ctx.submitBtn.getAttribute('data-socd-req-owntexts') === '1') return;
    var m = (ctx.overlay.className || '').match(/socd__[a-z]+-([A-Za-z0-9_-]+)/);
    var uid = m ? m[1] : '';
    if (uid && t.ctaSub) {
      var hint = document.querySelector('.socd__hint-' + uid);
      if (hint) hint.textContent = t.ctaSub;
    }
    var sub = ctx.overlay.querySelector('[data-socd-step="choice"] p');
    if (sub && t.choiceSub) sub.textContent = t.choiceSub;

    /* Зелена «гарантійна» плашка візарда (дедлайн/фінал) і дрібний текст під
       нею — теж із pay-first світу («повернемо 100% оплати»). У заявці
       повертати нічого: грошей ще не було. */
    var guar = ctx.overlay.querySelector('[data-socd-guar]');
    if (guar) {
      var gt = guar.querySelector('[class*="guart"]');
      var gd = guar.querySelector('[class*="guard"]');
      if (gt && t.guarT) gt.textContent = t.guarT;
      if (gd && t.guarD) gd.textContent = t.guarD;
    }
    var fine = ctx.overlay.querySelector('[data-socd-fine]');
    if (fine && t.fineText) fine.textContent = t.fineText;
  }

  function init(ctx) {
    var t = texts(ctx);
    /* Написи фінальної кнопки/стану «шлю…» — свої. */
    if (t.submit) ctx.L.submit = t.submit;
    if (t.sending) ctx.L.submitting = t.sending;
    swapChoiceTexts(ctx, t);
    honestSubLines(ctx, t);
    injectContactUi(ctx, t);
    injectDoneStep(ctx, t);
  }

  window.BTDesignRequest = { init: init, submit: submit };
})();
